import { RemovableItemOrderType, ImprintType } from "../../../types/enums";

export const FULL_DENTURE_STEP_LABELS = {
  IMPRINT_TYPE: "Type d'empreinte",
  ORDER_TYPE: "Type de commande",
  DETAILS: "Détails",
  AESTHETICS: "Esthétique",
  SUMMARY: "Récapitulatif",
  RDV2_CHOICE: "Choix",
};

export const getStepperLabels = (
  orderType: RemovableItemOrderType | null
): string[] => {
  if (!orderType) {
    return [
      FULL_DENTURE_STEP_LABELS.IMPRINT_TYPE,
      FULL_DENTURE_STEP_LABELS.ORDER_TYPE,
    ];
  }

  const baseLabels = [
    FULL_DENTURE_STEP_LABELS.IMPRINT_TYPE,
    FULL_DENTURE_STEP_LABELS.ORDER_TYPE,
    FULL_DENTURE_STEP_LABELS.DETAILS,
    FULL_DENTURE_STEP_LABELS.AESTHETICS,
    FULL_DENTURE_STEP_LABELS.SUMMARY,
  ];

  switch (orderType) {
    case RemovableItemOrderType.WAX_BITE:
      // for wax bite we skip aesthetic
      return baseLabels.filter(
        label => label !== FULL_DENTURE_STEP_LABELS.AESTHETICS
      );
    case RemovableItemOrderType.TRY_IN:
    case RemovableItemOrderType.FINAL:
    default:
      return baseLabels;
  }
};

export const getRdv2StepperLabels = (
  orderType: RemovableItemOrderType | null
): string[] => {
  if (!orderType) {
    return [FULL_DENTURE_STEP_LABELS.RDV2_CHOICE];
  }
  // for wax bite no aesthetic
  if (orderType === RemovableItemOrderType.WAX_BITE) {
    return [
      FULL_DENTURE_STEP_LABELS.RDV2_CHOICE,
      FULL_DENTURE_STEP_LABELS.DETAILS,
      FULL_DENTURE_STEP_LABELS.SUMMARY,
    ];
  }

  // for try in or direct finish: details + aesthetics
  return [
    FULL_DENTURE_STEP_LABELS.RDV2_CHOICE,
    FULL_DENTURE_STEP_LABELS.DETAILS,
    FULL_DENTURE_STEP_LABELS.AESTHETICS,
    FULL_DENTURE_STEP_LABELS.SUMMARY,
  ];
};

export const shouldShowAestheticsStep = (
  orderType: RemovableItemOrderType | null
): boolean => {
  if (!orderType) return false;

  return [RemovableItemOrderType.TRY_IN, RemovableItemOrderType.FINAL].includes(
    orderType
  );
};

export const getRdvNumberFromImprintType = (
  imprintType: ImprintType
): number => {
  if (imprintType === ImprintType.WAX_BITE_RDV2) {
    return 2;
  }

  return 1; // EDENTULOUS_ARCH_RDV1 or PRE_EXISTING_DENTURE_RDV1
};
